/* src/app/workshop/modals/defect-doc-modal/defect-doc-modal.component.scss */
/*# sourceMappingURL=defect-doc-modal.component.css.map */
